export const SUPPORT_EMAIL = 'nishalamv@gmail.com';
export const SUPPORT_EMAIL_2 = 'nishal@nishal.dev';
export const SUPPORT_WHATSAPP_E164 = '918089392112';
export const SUPPORT_WHATSAPP_DISPLAY = '+91 80893 92112';

export const PRIVACY_URL = 'https://privacy.nmhelper.in/';
export const TERMS_URL = 'https://terms.nmhelper.in/';
export const DELETE_DATA_URL = 'https://privacy.nmhelper.in/delete-data.html';
export const HELP_URL = 'https://nmhelper.in/help/';
/** Main downloadable user guide (head & teacher). */
export const HELP_PDF_URL = 'https://nmhelper.in/help/NMHelper.pdf';
export const HELP_PDF_EN_URL = 'https://nmhelper.in/help/NMhelper-User-Guide-Eng.pdf';
export const HELP_PDF_ML_URL = 'https://nmhelper.in/help/NMhelper-User-Guide-ML.pdf';

/** Interactive help — pass app Malayalam toggle so the guide opens in the same language. */
export function getHelpUrl(useMalayalam = false) {
  const lang = useMalayalam ? 'ml' : 'en';
  return `${HELP_URL}?lang=${lang}`;
}

const WHATSAPP_PREFILL = 'Hi, I need help with NMhelper login.';

const DATA_DELETION_SUBJECT = 'NMhelper data deletion request';
const DATA_DELETION_BODY = `Please delete my NMhelper data.

School / institution name:
My role (head / teacher / school contact):
Username in NMhelper:
Registered name (if any):

What to delete (my account / teacher account / entire school):

I confirm I am authorized to request this deletion.

Additional notes (optional):
`;

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const SUPPORT_MAILTO_2 = `mailto:${SUPPORT_EMAIL_2}`;
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP_E164}?text=${encodeURIComponent(WHATSAPP_PREFILL)}`;
export const DATA_DELETION_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(DATA_DELETION_SUBJECT)}&body=${encodeURIComponent(DATA_DELETION_BODY)}`;
